import { bl_fi_commission_scheme_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class CommissionSchemeContainerModel extends BaseContainerModel {
  bl_fi_commission_scheme_hdr: bl_fi_commission_scheme_hdr_RowClass = new bl_fi_commission_scheme_hdr_RowClass();
}